const randomString = (): string => {
    return Math.random().toString(36).substring(8);
};

export default randomString;
